export const getInitialsImage = (name: string) => {
  if (!name) return null;
  const initials = name.split(" ").map((part) => part.charAt(0).toUpperCase());
  return (
    <div className="w-10 h-10 bg-[#F15D18] rounded-full overflow-hidden">
      <div className="flex items-center justify-center h-full text-white font-bold">
        {initials.join("")}
      </div>
    </div>
  );
};
export const mapSingleRole = (role: string) => {
  if (role.includes("team_lead")) {
    return "team";
  } else if (role.includes("team_member")) {
    return "user";
  } else {
    return "unknown"; // Fallback for undefined roles
  }
};
export const getNameFromEmail = (email: string) => {
  if (!email || typeof email !== "string") {
    throw new Error("Invalid email address");
  }

  // Split the email to extract the part before '@'
  const namePart = email.split("@")[0];

  // Split the namePart by '.' or other separators (if any)
  const nameSegments = namePart.split(/[.\-_]/);

  // Capitalize each segment and join them back with a space
  const formattedName = nameSegments
    .map(
      (segment) =>
        segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase()
    )
    .join(" ");

  return formattedName;
};

export const TooltipPackageData = 
[
  {
    status: false,
    packageId: "T004",
    packageName: "Onboarding",
    expertName: "Onboarding",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 1,
    sales: "04",
    earnings: "134.55",
  },
  {
    status: false,
    packageId: "T004",
    packageName: "Onboarding",
    expertName: "Onboarding",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 1,
    sales: "04",
    earnings: "134.55",
  },
  {
    status: false,
    packageId: "T005",
    packageName: "Help section",
    expertName: "Help section",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 4,
    sales: "04",
    earnings: "134.55",
  },
  {
    status: false,
    packageId: "T006",
    packageName: "Guide",
    expertName: "Guide",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 5,
    sales: "04",
    earnings: "29.99",
  },
  {
    status: false,
    packageId: "T007",
    packageName: "Expert tips",
    expertName: "Expert tips",
    created: "12/01/2025",
    lastSale: "-",
    ratings: "-",
    sales: "00",
    earnings: "0",
  },
  {
    status: false,
    packageId: "T008",
    packageName: "Notes",
    expertName: "Notes",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 5,
    sales: "04",
    earnings: "134.55",
  },
  {
    status: false,
    packageId: "T009",
    packageName: "Document",
    expertName: "Document",
    created: "12/01/2025",
    lastSale: "-",
    ratings: "-",
    sales: "00",
    earnings: "0",
  },
  {
    status: false,
    packageId: "T010",
    packageName: "Concepts",
    expertName: "Concepts",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 1,
    sales: "04",
    earnings: "76.75",
  },
  {
    status: false,
    packageId: "T011",
    packageName: "Pointers",
    expertName: "Pointers",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 4,
    sales: "04",
    earnings: "134.55",
  },
  {
    status: false,
    packageId: "T012",
    packageName: "Summary",
    expertName: "Summary",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 4,
    sales: "04",
    earnings: "88.99",
  },
  {
    status: false,
    packageId: "T013",
    packageName: "Brand theory",
    expertName: "Brand theory",
    created: "12/01/2025",
    lastSale: "14/01/2025",
    ratings: 2,
    sales: "04",
    earnings: "198.70",
  },
];

export const TooltipSalesData = [
  {
    packageId: "T004",
    packageName: "Onboarding",
    expertName: "Jenny Wilson",
    customerName: "Jenny dd",
    purchased: "12/01/2025",
    ratings: 1,
    reviews: "A nice experience of onboarding.",
    earnings: "134.55",
  },
  {
    packageId: "T003",
    packageName: "Onboarding",
    expertName: "Jenny Wilson",
    customerName: "Jenny Wilson",
    purchased: "12/01/2025",
    ratings: 1,
    reviews: "A nice experience of onboarding.",
    earnings: "134.55",
  },
  {
    packageId: "T005",
    packageName: "Help section",
    expertName: "Wade Warren",
    customerName: "Wade Warren",
    purchased: "12/01/2025",
    ratings: 4,
    reviews: "A nice experience of help section.",
    earnings: "134.55",
  },
  {
    packageId: "T006",
    packageName: "Guide",
    expertName: "Esther Howard",
    customerName: "Esther Howard",
    purchased: "12/01/2025",
    ratings: 5,
    reviews: "A nice experience of guide.",
    earnings: "29.99",
  },
  {
    packageId: "T007",
    packageName: "Expert tips",
    expertName: "Tim David",
    customerName: "Tim David",
    purchased: "12/01/2025",
    ratings: 3,
    reviews: "A nice experience of tips.",
    earnings: "0",
  },
  {
    packageId: "T008",
    packageName: "Notes",
    expertName: "Guy Hawkins",
    customerName: "Guy Hawkins",
    purchased: "12/01/2025",
    ratings: 5,
    reviews: "A nice experience of notes.",
    earnings: "134.55",
  },
  {
    packageId: "T009",
    packageName: "Document",
    expertName: "Jacob Jones",
    customerName: "Jacob Jones",
    purchased: "12/01/2025",
    ratings: 5,
    reviews: "A nice experience of document.",
    earnings: "0",
  },
  {
    packageId: "T010",
    packageName: "Concepts",
    expertName: "Ronald Richards",
    customerName: "Ronald Richards",
    purchased: "12/01/2025",
    ratings: 1,
    reviews: "A nice experience of concepts.",
    earnings: "76.75",
  },
  {
    packageId: "T011",
    packageName: "Pointers",
    expertName: "Devon Lane",
    customerName: "Devon Lane",
    purchased: "12/01/2025",
    ratings: 4,
    reviews: "A nice experience of pointers.",
    earnings: "134.55",
  },
  {
    packageId: "T012",
    packageName: "Summary",
    expertName: "Rebeca Sands",
    customerName: "Rebeca Sands",
    purchased: "12/01/2025",
    ratings: 4,
    reviews: "A nice experience of summary.",
    earnings: "88.99",
  },
  {
    packageId: "T013",
    packageName: "Brand theory",
    expertName: "Gary Smith",
    customerName: "Gary Smith",
    purchased: "12/01/2025",
    ratings: 2,
    reviews: "A nice experience of brand theory.",
    earnings: "198.70",
  },
];
